module.exports = "<app-list-org></app-list-org>\n<app-rolelist></app-rolelist>\n<app-list-user></app-list-user>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/email/send/send.component.html
// module id = ../../../../../src/app/admin/email/send/send.component.html
// module chunks = main